
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

interface DoseSelectionCardProps {
  medication: string;
  doseType: "standard" | "max";
  onDoseTypeChange: (doseType: "standard" | "max") => void;
  qualifiesForMaxDose: boolean;
}

export const DoseSelectionCard = ({ medication, doseType, onDoseTypeChange, qualifiesForMaxDose }: DoseSelectionCardProps) => {
  const standardDoseText = medication === "semaglutide" ? "1mg per week" : "7.5mg per week";
  const maxDoseText = medication === "semaglutide" ? "2.5mg per week" : "10mg per week";

  const handleToggleChange = (checked: boolean) => {
    // Only allow switching to max if qualified
    if (checked && !qualifiesForMaxDose) {
      return;
    }
    onDoseTypeChange(checked ? "max" : "standard");
  };

  return (
    <Card className="p-6">
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Select Your Dose</h3>
        <div className="flex items-center justify-between">
          <div>
            <Label className="text-base">
              {doseType === "standard" ? "Standard Dose" : "Maximum Dose"}
            </Label>
            <p className="text-sm text-muted-foreground">
              {doseType === "standard" ? standardDoseText : maxDoseText}
            </p>
          </div>
          <Switch
            checked={doseType === "max"}
            onCheckedChange={handleToggleChange}
            disabled={!qualifiesForMaxDose && doseType !== "max"}
          />
        </div>
        
        {!qualifiesForMaxDose && (
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              Max dose is only available if you've taken the exact same medication in the last 8 weeks.
            </AlertDescription>
          </Alert>
        )}
      </div>
    </Card>
  );
};
